module.exports = __webpack_public_path__ + "static/media/Infotos-sample1.9e1b2b63.jpg";